import { render, staticRenderFns } from "./vue-bigdata-table.vue?vue&type=template&id=78fc8e1a"
import script from "./vue-bigdata-table.vue?vue&type=script&lang=js"
export * from "./vue-bigdata-table.vue?vue&type=script&lang=js"
import style0 from "./vue-bigdata-table.vue?vue&type=style&index=0&id=78fc8e1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports